<template>
  <div>
    <vx-card>
      <h4 class="mb-5">Filtros</h4>
      <div class="vx-row">
        <div class="vx-col md:w-1/3 w-full">
          <h6 class="mb-2">Código</h6>
          <v-select
            name="codigo"
            label="codigo"
            multiple
            v-model="filters.codigo"
            :options="getProductCodes">
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                Nenhuma resultado encontrado para <em>{{ search }}</em>.
              </template>
              <em style="opacity: 0.5;" v-else>Nenhum resultado encontrado</em>
            </template>
          </v-select>
        </div>
        <div class="vx-col md:w-1/3 w-full">
          <h6 class="mb-2">Marca</h6>
          <v-select
            name="marca"
            label="marca"
            multiple
            v-model="filters.marca"
            :options="getBrands">
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                Nenhuma resultado encontrado para <em>{{ search }}</em>.
              </template>
              <em style="opacity: 0.5;" v-else>Nenhum resultado encontrado</em>
            </template>
          </v-select>
        </div>
        <div class="vx-col md:w-1/3 w-full">
          <h6 class="mb-2">Modelo</h6>
          <v-select
            name="modelo"
            label="modelo"
            multiple
            v-model="filters.modelo"
            :options="getModels">
            <template v-slot:no-options="{ search, searching }">
              <template v-if="searching">
                Nenhuma resultado encontrado para <em>{{ search }}</em>.
              </template>
              <em style="opacity: 0.5;" v-else>Nenhum resultado encontrado</em>
            </template>
          </v-select>
        </div>
      </div>
      <br>
      <div class="flex flex-wrap items-center" slot="footer">
        <vs-button class="mr-6" @click="generateStockPDF()">Gerar PDF</vs-button>
        <vs-button @click="generateStockXlsx()">Gerar XLSX</vs-button>
      </div>
      <p style="font-style: oblique; font-size: 12px;">Para selecionar todos os resultados, deixe o campo em branco.</p>
      <StockPdf ref="stockPdf"></StockPdf>
      <StockXlsx ref="stockXlsx"></StockXlsx>
    </vx-card>
  </div>
</template>
<script>
import StockPdf from './StockPdf.vue'
import StockXlsx from './StockXlsx.vue'
export default {
  data() {
    return {
      filters: {
        codigo: [],
        marca: [],
        modelo: []
      }
    }
  },
  components: {
    StockPdf,
    StockXlsx
  },
  computed: {
    getProductCodes() {
      return this.getUniquesByColumnAndSort('codigo')
    },
    getBrands() {
      return this.getUniquesByColumnAndSort('marca')
    },
    getModels() {
      return this.getUniquesByColumnAndSort('modelo')
    },
  },
  methods: {
    getUniquesByColumnAndSort(column) {
      const products = this.$store.state.products
      const results = products.map(product => product[column])
      const uniqueResults = [...new Set(results)];

      const uniqueResultsSorted = uniqueResults.sort((a, b) => a.localeCompare(b))

      return uniqueResultsSorted
    },
    generateStockPDF() {
      const filterHaveMatch = this.$refs.stockPdf.generate(this.filters)
      if (!filterHaveMatch) {
        this.$vs.notify({
          title: 'Erro',
          text: 'Os filtros selecionados não correspondem a nenhum produto.',
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        })
      }
    },
    async generateStockXlsx() {
      await this.$refs.stockXlsx.generate(this.filters)
    }
  },
  async created() {
    const payload = {
      loading: this.$vs.loading
    }
    await this.$store.dispatch("fetchProductsItems", payload)
  },
}

</script>
